// extracted by mini-css-extract-plugin
module.exports = {"content":"AdministrativePolicies_content__ge29v","text":"AdministrativePolicies_text__2W5qT"};